import React from 'react';
import { NavLink } from "react-router-dom";
import Button from '@material-ui/core/Button';
import useStyles from './styles';
import {useSelector} from "react-redux";

const ProfileTabs = ({ userId }) => {
  const classes = useStyles();
  const user = useSelector(s => s.user.user);

  return (
    <div className={classes.tabsRoot}>
      <div className={classes.tabs}>
        <Button
          exact
          component={NavLink}
          to={`/hcs/${userId}/profile/general`}
          variant="outlined"
          color="primary"
        >
          General Info
        </Button>
        <Button
          component={NavLink}
          to={`/hcs/${userId}/profile/calendar`}
          variant="outlined"
          color="primary"
        >
          Calendar
        </Button>
        {user.type === 'admin' && (
          <Button
            component={NavLink}
            to={`/hcs/${userId}/profile/students`}
            variant="outlined"
            color="primary"
          >
            Students
          </Button>
        )}
        <Button
          component={NavLink}
          to={`/hcs/${userId}/profile/settings`}
          variant="outlined"
          color="primary"
        >
          Notification Settings
        </Button>
      </div>
    </div>
  );
};

export default ProfileTabs;
